export enum ProductPlatform {
  Web = 'web',
  App = 'app',
}
